import { camelCase } from './string_utils.js'

/**
 * Description
 *  Allows to have params for events with the same sintax as Stimulus 3.0.
 *  Currently all params value are strings.
 *  This could be extended to automatically detect the value type and convert it accordingly.
 *
 * Reasoning
 *  This was created because we needed this feature,
 *  but couldn't update stimulus due to lack of support for IE11.
 *
 * How to use it
 *  1. Import the actionParamsFromEvent const in your stimulus controller.
 *  2. Inside an action call the method to get the params declared in the HTML.-bottom-0
 *    Example
 *      Assuming "printer" as the stimulus controller that the method it's used with.
 *      Param declaration on HTML:
 *      <div data-printer-size-param='10' >
 *
 *      Stimulus Action on "printer" stimulus controller:
 *      printSize(event){
 *        const { size } = actionParamsFromEvent(this, event)
 *        console.log(size)
 *      }
 *
 *
 *
 * @param {stimulus controller} c
 * @param {browser event} event
 */
export const actionParamsFromEvent = (c, event) => {
  const ct = event.currentTarget
  if (!ct.hasAttributes()) { return {} }

  const paramPrefix = `data-${c.identifier}-`
  const paramSuffix = '-param'

  const paramShortName = (paramFullName) => {
    const fromIndex = paramFullName.indexOf(paramPrefix) + paramPrefix.length
    const toIndex = paramFullName.indexOf(paramSuffix)
    if (fromIndex >= toIndex) { return null }
    return paramFullName.substring(fromIndex, toIndex)
  }

  const params = {}

  for (const attr of ct.attributes) {
    const name = attr.name
    if (name.indexOf(paramPrefix) === 0 && name.endsWith(paramSuffix)) {
      const key = camelCase(paramShortName(name))
      params[key] = attr.value
    }
  }

  return params
}
